<template>
	<div class="page page-2">
		<VideoModal v-if="video" @close="video = false" video="BpzblZceMDg" />
		<Header v-if="!lastScreen" :fixed="stickHeader" @toggleMenu="menu = !menu" :menu="menu" :active="activeScreen" color="red" backEvent="ritm_knopka_nazad" backEventm="m_ritm_knopka_nazad" />
		<QuizButton v-if="!lastScreen" />
		<Lines v-if="!lastScreen" :load="load" />
		<Social v-if="!lastScreen" />
		<full-page ref="fullpage" :options="options" id="fullpage">
			<div class="section">
				<Screen event1="ritm_seul_video" event1_m="m_ritm_seul_video" :active="activeScreen"  :button="false" :number="1" color="red" align="right" :hasTitle="true" @video="video = true" titleClass="screen__heading--1" link="https://www.youtube.com/watch?v=4b_IMotQc7s" vimeo="557277031">
					<template v-slot:heading-title>
						Держи ритм! <span>Регионы Кореи</span>
					</template>
					<template v-slot:title>
						Сеул
					</template>
					<template v-slot:text>
						Столица Южной Кореи величественна. Здесь можно <br>настроиться на серьезный лад и осмотреть Токсугун — <br>один из «Пяти великих дворцов» эпохи Чосон. А у <br>ворот Тэханмун — наблюдать смену императорского <br>караула. Но Сеул это не только торжественность, здесь <br>любят и веселье. Хотите увидеть тоннель Чахамун, где <br>снимали знаменитый фильм «Паразиты»? Возможно, <br>вам повезет застать один из миллиона смешных <br>флешмобов, на которые корейцы такие мастера.
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-11.jpg" alt="" @>
					</template>
				</Screen>
			</div>
			<div class="section">
				<Screen event1="ritm_pusan_video" event1_m="m_ritm_pusan_video" :active="activeScreen"  :button="false" :number="2" color="blue" align="left" :hasTitle="false" @video="video = true" link="https://www.youtube.com/watch?v=t3d-aQHmLgY" vimeo="557276847">
					<template v-slot:title>
						Пусан
					</template>
					<template v-slot:text>
						Веселый портовый город может показать много <br>интересного. Выберите время, чтобы посетить <br>культурную деревню Камчхон с аккуратно <br>выстроенными домиками всех цветов. Съездите <br>в буддийский храм Хэдон Ёнгунса, где танцуют все: <br>корейская молодежь, туристы и даже монахи. <br>Отправляйтесь на пляж Кваналли полюбоваться морем <br>и обязательно отведайте рыбу хве в местном ресторане.
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-12.jpg" alt="">
					</template>
				</Screen>
			</div>
			<div class="section">
				<Screen event1="ritm_chondzhu_video" event1_m="m_ritm_chondzhu_video" :active="activeScreen"  :button="false" :number="3" color="yellow" align="right" :hasTitle="false" @video="video = true" link="https://www.youtube.com/watch?v=8n74K8CfzC0" vimeo="557276683">
					<template v-slot:title>
						Чонджу
					</template>
					<template v-slot:text>
						Это очень важный город — здесь находится усыпальница <br>Ли Тхэджо, родоначальника династии Ли и основателя <br>государства Чосон. После ее осмотра отправляйтесь <br>в Деревню традиционных домов ханок, чтобы <br>полюбоваться корейской стариной, и не забудьте <br>заглянуть на обед в местные рестораны, которые славятся <br>национальной кухней. А на десерт — традиционная <br>корейская музыка пхансори и народные песни <br>сориккун в культурном центре «Сори».
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-13.jpg" alt="">
					</template>
				</Screen>
			</div>
			<div class="section">
				<Screen event1="ritm_mokpho_video" event1_m="m_ritm_mokpho_video" :active="activeScreen"  :button="false" :number="4" color="purpure" align="left" :hasTitle="false" @video="video = true" link="https://www.youtube.com/watch?v=BQ00xPku1Ms&t=6s" vimeo="557276113">
					<template v-slot:title>
						Мокпхо
					</template>
					<template v-slot:text>
						Этот приморский город всегда рад гостям. Здесь можно отведать свежайших даров моря. Местные маленькие осьминожки "сэбаль нокчи" хорошо известны по всмей Корее. Морская канатная <br>дорога тянется более 3 километров над побережьем <br>и заливом, виды на закат и вечерний порт запомнятся <br>навсегда. Как и величественные горы Юдальсан, откуда <br>открывается потрясающий вид на корабли в заливе.
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-14.jpg" alt="">
					</template>
				</Screen>
			</div>
			<div class="section">
				<Screen event1="ritm_kannyn_video" event1_m="m_ritm_kannyn_video" :active="activeScreen"  :button="false" :number="5" color="red" align="right" :hasTitle="false" @video="video = true" link="https://www.youtube.com/watch?v=iVoMzmciPww" vimeo="557275225">
					<template v-slot:title>
						Каннын
					</template>
					<template v-slot:text>
						Этот город полон развлечений, его любят молодые <br>корейцы и звезды шоу-бизнеса. Когда на побережье <br>Хянхо построили автобусную остановку для <br>фотосессии группы BTS, после съемок ее превратили <br>в фотозону для фанатов и туристов. Также в Канныне <br>находятся самая большая на Востоке статуя Будды <br>и буддийский храм Наксанса, построенный в VII веке, <br>где проходят музыкальные выступления и флешмобы.
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-15.jpg" alt="">
					</template>
				</Screen>
			</div>
			<div class="section">
				<Screen event1="ritm_andon_video" event1_m="m_ritm_andon_video" :active="activeScreen"  :button="false" :number="6" color="blue" align="left" :hasTitle="false" @video="video = true" link="https://www.youtube.com/watch?v=HGSAl2M8jSI" vimeo="557275696">
					<template v-slot:title>
						Андон
					</template>
					<template v-slot:text>
						Этот город — один из центров корейской духовности. <br>Конфуцианская академия Пёнсан совон, построенная <br>в гармонии с окружающей природой, позволит <br>окунуться в жизнь ученых времен государства Чосон. <br>Но в Андоне не только размышляют, здесь есть <br>собственные ритмы. Тут снимались сериалы <br>«Королевство» и «Солнечный свет», а в деревне Хахве <br>можно насладиться танцами в масках хахве <br>и традициями культуры дворянского сословия янбан.
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-16.jpg" alt="">
					</template>
				</Screen>
			</div>
			<div class="section">
				<Screen event1="ritm_chedzhu_video" event1_m="m_ritm_chedzhu_video" :active="activeScreen"  :button="false" :number="7"  color="yellow" align="right" :hasTitle="false" @video="video = true" link="https://www.youtube.com/watch?v=S_ue9nXtGJ0" vimeo="557276495">
					<template v-slot:title>
						Чеджу
					</template>
					<template v-slot:text>
						Этот самый большой остров Южной Кореи <br>по-настоящему уникален. Он входит в список <br>Всемирного наследия ЮНЕСКО, но заслуженно <br>славится не только своей прекрасной природой, <br>главное чудо здесь — люди и совершенно особенная <br>культура. Помимо других особенностей, Чеджу — <br>родина легендарных ныряльщиц хэнё, которые <br>в поисках моллюсков, водорослей и других даров <br>моря погружались на большую глубину.
					</template>
					<template v-slot:image>
						<img src="@/assets/images/image-17.jpg" alt="">
					</template>
				</Screen>
			</div>
			<div class="section fp-auto-height">
				<Bottom link1="/vr" link2="/tropa" link3="/chudo"
					event1="ritm_vr_tury"
					event1_m="m_ritm_vr_tury"
					event3="ritm_prirodnoe_nasledie"
					event3_m="m_ritm_prirodnoe_nasledie"
					event2="ritm_kulturnoe_nasledie"
					event2_m="m_ritm_kulturnoe_nasledie"
				>
					<template v-slot:image-3>
						<img src="@/assets/images/bottom-1.jpg" alt="">
					</template>
					<template v-slot:title-3>
						Чудеса природы
					</template>
					<template v-slot:subtitle-3>
						Природное наследие
					</template>
					<template v-slot:image-1>
						<img src="@/assets/images/bottom-3.jpg" alt="">
					</template>
					<template v-slot:title-1>
						Полное погружение
					</template>
					<template v-slot:subtitle-1>
						VR-туры
					</template>
					<template v-slot:image-2>
						<img src="@/assets/images/bottom-2.jpg" alt="">
					</template>
					<template v-slot:title-2>
						Пройдись <br>по тропе истории
					</template>
					<template v-slot:subtitle-2>
						Культурное наследие 
					</template>
				</Bottom>
			</div>
		</full-page>
	</div>
</template>

<script>
	import VideoModal from '@/components/VideoModal'
	import AOS from 'aos';
	import 'aos/dist/aos.css';
	import Screen from '@/components/Page/Screen'
	import Header from '@/components/Header'
	import QuizButton from '@/components/QuizButton'
	import Lines from '@/components/Lines'
	import Social from '@/components/Social'
	import Bottom from '@/components/Bottom'
	export default {
		data() {
			return {
				lastScreen: false,
				video: false,
				load: false,
				menu: false,
				stickHeader: false,
				activeScreen: 1,
				scrolls: {
					scroll_25: false,
					scroll_50: false,
					scroll_75: false,
					scroll_100: false,
				},
				options: {
					scrollingSpeed: 700,
					onLeave: this.onLeave,
					responsiveWidth: 1000,
					licenseKey: '8CF2D987-42B5463E-99932468-42A81BB3'
				}
			}
		},
		components: {
			Screen,
			Header,
			QuizButton,
			Lines,
			Social,
			Bottom,
			VideoModal,
		},
		methods: {
			scrollEvent() {
				if (document.documentElement.scrollTop > 250) {
					this.stickHeader = true;
				} else {
					this.stickHeader = false;
				}
				var h = document.documentElement, 
						b = document.body,
						st = 'scrollTop',
						sh = 'scrollHeight';

				var precent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
				if (precent > 25 && !this.scrolls.scroll_25) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_ritm_scroll_25'});
					this.scrolls.scroll_25 = true;
				}
				if (precent > 50 && !this.scrolls.scroll_50) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_ritm_scroll_50'});
					this.scrolls.scroll_50 = true;
				}
				if (precent > 75 && !this.scrolls.scroll_75) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_ritm_scroll_75'});
					this.scrolls.scroll_75 = true;
				}
				if (precent > 95 && !this.scrolls.scroll_100) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_ritm_scroll_100'});
					this.scrolls.scroll_100 = true;
				}
			},
			onLeave(page, p, direction) {
				this.activeScreen = p.index + 1;
				if (page.index == 6 && direction == 'down') {
					this.lastScreen = true;
				} else {
					this.lastScreen = false;
				}
				if (this.activeScreen == 2) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'ritm_scroll_25'});
				}
				if (this.activeScreen == 4) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'ritm_scroll_50'});
				}
				if (this.activeScreen == 6) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'ritm_scroll_75'});
				}
				if (this.activeScreen == 7) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'ritm_scroll_100'});
				}
			},
		},
		created () {
			window.addEventListener('scroll', this.scrollEvent);
		},
		destroyed () {
			window.removeEventListener('scroll', this.scrollEvent);
		},
		mounted() {
			AOS.init();
			this.$refs.fullpage.api.reBuild();
			if (window.innerWidth < 960) {
				this.$refs.fullpage.api.destroy('all');
			}
			//this.$refs.fullpage.api.setAllowScrolling(false);
		}
	}
</script>
